// extracted by mini-css-extract-plugin
export default {"cls1":"MenuItem-cls1_sU4","cls2":"MenuItem-cls2_TXH MenuItem-cls1_sU4"};